export const bandeiras = {
  visa: 'VISA',
  mastercard: 'MASTERCARD',
  americanExpress: 'AMERICAN_EXPRESS',
  elo: 'ELO',
  outro: 'OUTRO',
};
